import React, { Fragment, useMemo, useState } from "react";
import swal from "sweetalert";
import { useHistory } from "react-router-dom";
import { Button } from "react-bootstrap";
import { useAuth } from "../../../../context/AuthContext";
import { usePaymentAccessScope } from "../../../../hook/usePaymentAccessScope";

import PageTitle from "../../../layouts/PageTitle";
import DoctorItem from "./DoctorItem";
import DoctorRegister from "./DoctorRegister";
import DoctorEdit from "./DoctorEdit";

import { useCollection } from "../../../../hook/useCollection";
import { useFirestore } from "../../../../hook/useFirestore";

import { useQuery } from "../../../../hook/useQuery";

const DoctorItemList = () => {
  const { currentUser } = useAuth();
  const [showRegisterModal, setShowRegisterModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [itemEdit, setItemEdit] = useState({});
  const { paymentAccess } = usePaymentAccessScope();

  const history = useHistory();
  const searchParams = useQuery();
  const param = searchParams.get("q");

  const { documents: doctors, error } = useCollection("doctors");
  const doctorItemList = useMemo(
    () =>
      doctors
        .filter((doctor) => !param || String(doctor.name || "").startsWith(param))
        .sort((a, b) => {
          const firstId = a.doctorId || "";
          const secondId = b.doctorId || "";
          return firstId < secondId ? -1 : firstId > secondId ? 1 : 0;
        }),
    [doctors, param]
  );

  const { deleteDocument } = useFirestore("doctors");

  const handleSearchChange = (event) => {
    history.replace({
      search: new URLSearchParams({ q: event.target.value }).toString(),
    });
  };

  const handleOnNewItem = () => {
    setShowRegisterModal(true);
  };

  const handleOnEdit = async (id) => {
    setItemEdit(doctorItemList.find((c) => c.id === id));
    setShowEditModal(true);
  };

  const handleOnRegisterHide = (sn) => {
    setShowRegisterModal(false);
  };
  const handleOnEditHide = (sn) => {
    setShowEditModal(false);
  };

  const handleOnDelete = (id) => {
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this file!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        deleteDocument(id)
          .then(() => {
            swal(`Poof! Your file has been deleted!`, {
              icon: "success",
            });
          })
          .catch((err) => {
            swal(`Poof! ${err}`, {
              icon: "error",
            });
          });
      } else {
        swal("Canceled");
      }
    });
  };

  return (
    <Fragment>
      <PageTitle activeMenu="Item List" motherMenu="Items" />
      <div className="form-head d-flex mb-3 mb-lg-5 align-items-center">
        <Button
          onClick={handleOnNewItem}
          className="btn btn-danger"
          data-toggle="tooltip"
          data-placement="top"
          title="Item Registration"
        >
          + New Doctor
        </Button>

        <div className="input-group search-area ml-auto d-inline-flex">
          <input
            type="text"
            className="form-control"
            placeholder="Search Name"
            onChange={handleSearchChange}
            value={param || ""}
          />
          <div className="input-group-append">
            <span className="input-group-text c-pointer">
              <i className="flaticon-381-search-2"></i>
            </span>
          </div>
        </div>
      </div>

      {error && (
        <div className="alert alert-danger" role="alert">
          Unable to load doctors. Please reload the page and try again.
        </div>
      )}
      <DoctorRegister
        show={showRegisterModal}
        hide={handleOnRegisterHide}
        currentUser={currentUser}
        paymentAccess={paymentAccess}
      />
      <DoctorEdit
        item={itemEdit}
        show={showEditModal}
        hide={handleOnEditHide}
        currentUser={currentUser}
        paymentAccess={paymentAccess}
      />
      <DoctorItem
        items={doctorItemList}
        onEdit={handleOnEdit}
        onDelete={handleOnDelete}
        currentUser={currentUser}
        paymentAccess={paymentAccess}
      />
    </Fragment>
  );
};

export default DoctorItemList;
